import { render, staticRenderFns } from "./FormLocation.vue?vue&type=template&id=bf00d47a&scoped=true&"
import script from "./FormLocation.vue?vue&type=script&lang=js&"
export * from "./FormLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf00d47a",
  null
  
)

export default component.exports